import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

@Injectable({
  providedIn: 'root'
})
export class BrowserService {

  open(url: string) {
    try {
      if (Capacitor.isNativePlatform()) {
        // Native (iOS/Android) → use Capacitor Browser
        Browser.open({
          url,
          toolbarColor: window.getComputedStyle(document.documentElement)
            .getPropertyValue('--ion-color-primary')
        });
      } else {
        // Web fallback → open in a new tab
        window.open(url, '_blank');
      }
    } catch (error) {
      console.error('Error opening browser:', error);
    }
  }
}
